<template>
    <div class="d-flex flex-column">
    <b-dropdown offset="25" size="200"
      variant="light text-center"
      :text="title"      
      class="mt-2">

      <b-dropdown-item-button active-class="text-danger"  v-for="(service,index) in getServices" :key="index"  @click="setService(service)" >
        {{service.name }}
      </b-dropdown-item-button>

    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "ShopVoucherServicePriceList",
  props: ["getSelectedItemId"],
  data() { return {
    title: 'Betrag wählen'
  }},
  methods: {    
    setService: function(service){
      //console.log('set service: ', service);
      
      this.getSelectedItem.count = 1;
      this.getSelectedItem.selectedPrice = service.title;
      
      this.title = service.title.toFixed(2) + ' EUR';

      // emit warning message cleanup
    },
    getTotalSum: function() {       
      return  this.getSelectedItem.count.toFixed(2);
    },
    getCachedItem() {
      return this.$store.getters.getCachedItemById(this.getSelectedItemId);
    },    
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    },
    getLanguageItem: function() {
      return this.$store.getters.getLanguageStrings;
    },
    getServices() {
      return this.getSelectedItem.prices;
    },
    getSelectedItem() {
      return this.getCachedItem();
    }    
  },
  beforeMount() {
   // console.log("ShopVoucherServicePriceList:" + this.getSelectedItem.prices.length );
  },
  mounted(){
    this.setService(this.getServices[0]);
  }
};
</script>
